//export const BackendUrl = "127.0.0.1:8080"
export const BackendUrl = "/api"
//export const BackendUrl = "http://localhost:8080/api"
//proxy for package.json: "proxy": "http://localhost:8080/api",